import SvgIcon from '@material-ui/core/SvgIcon';

const PercentIcon = ({ ...props }) => (
  <SvgIcon {...props}>
    <path d="M18.501 3.5l-15 15.001l1.996 1.996l15-15zM7.002 5a2 2 0 1 0-.004 4a2 2 0 0 0 .004-4zm10 10a2 2 0 1 0-.004 4a2 2 0 0 0 .004-4z" />
  </SvgIcon>
);

export default PercentIcon;
